import { useState } from 'react';
import { useRootStore } from '../../../stores/useRootStore';
import { cancelService } from '../../../apiMethods/cancelService';
import { Skeleton } from '../../../components/Skeleton';
import { ButtonWithIcon } from '../ButtonWithIcon';
import BinIcon from '../../../assets/bin-icon.svg?react';
import { Chip } from '../components/Chip';
import { formatMoney } from '../../../utils/formatMoney';
import { formatTime } from '../../../utils/dates';
import { errorStore } from '../../../stores/errorStore';

type ServiceProps = {
  id: number;
  price: string;
  paid: boolean;
  quantity: number;
  refuse_guest: boolean;
  refuse_time: null | string;
  service: {
    id: number;
    name: string;
  };
  sub_service: null | {
    id: number;
    name: string;
  };
};

export const ServiceItem = ({
  loading,
  bookingId,
  service,
}: {
  service: ServiceProps;
  bookingId?: string;
  loading?: boolean;
}) => {
  const [cancellationPending, setPending] = useState(false);

  const { configStore, bookingsStore, confirmStore  } = useRootStore();
  const onCancelService = async () => {
    const hotelId = configStore.hotelId;

    if (!bookingId || !hotelId) {
      return;
    }

    const confirmed = await confirmStore.confirm({
      title: 'Внимание!',
      text: 'При отмене дополнительных услуг просим написать на почту sber@mriyaresort.com. В случае ранее внесенной предоплате потребуется запросить возврат денежных средств с указанием актуального бронирования и Ф.И.О. плательщика.',
    });

    if (!confirmed) {
      return;
    }

    try {
      setPending(true);
      await cancelService({ hotelId, bookingId: Number(bookingId), serviceId: service.id });

      bookingId && (await bookingsStore.loadBookingInfo(bookingId));
    } catch (err) {
      errorStore.setError(err as Error);
    } finally {
      setPending(false);
    }
  };

  return (
    <article
      className={`flex flex-col justify-between gap-2  pb-4 pt-3 xl:flex-row xl:gap-5 ${service.refuse_time ? 'text-neutral-50' : ''}`}
    >
      <div className={'flex flex-col text-lg'}>
        <p className="mb-1 font-medium leading-5">
          <Skeleton loading={loading} className="h-5 w-[240px]">
            {service.service.name}
            {service.sub_service?.name ? `: ${service.sub_service.name}` : ''}
          </Skeleton>
        </p>
        <div className="flex items-center">
          <p className="font-light">
            <Skeleton loading={loading} className="h-5 w-[80px]">
              {formatMoney(Number(service.price) * service.quantity)} &#8381;
              <span>
                {service.quantity > 1 && (
                  <span className="ml-4 text-neutral-70">
                    ({formatMoney(Number(service.price))} &#8381; x {service.quantity})
                  </span>
                )}
              </span>
            </Skeleton>
          </p>
          {service.paid == true && (
            <Skeleton loading={loading} className="h-5 w-[100px]">
              <Chip className="ml-5 text-xs">Оплачено</Chip>
            </Skeleton>
          )}
          {service.refuse_time == null && service.paid == false && (
            <Skeleton loading={loading} className="h-5 w-[100px]">
              <Chip className="ml-5 text-xs">Не оплачено</Chip>
            </Skeleton>
          )}
        </div>
      </div>
      <Skeleton loading={loading} className="w- h-6">
        {service.refuse_time ? (
          <div className="flex items-center text-sm">
            Отменено: {formatTime(service.refuse_time)}
          </div>
        ) : (
          <>
            {bookingsStore.bookingInfo?.read_only == false && (
              <ButtonWithIcon
                text="Удалить"
                icon={<BinIcon />}
                onClick={onCancelService}
                pending={cancellationPending}
              />
            )}
          </>
        )}
      </Skeleton>
    </article>
  );
};
